import React, {Component} from 'react';
import CartInfo from "./CartInfo";
import CartContent from "./CartContent";
import CapabilityContextProvider from "../global/context/CapabilityContext";
import CartDetailContextProvider from "./context/CartDetailContext";

class CartDetailComponent extends Component {
    render() {
        return (
            <CapabilityContextProvider>
                <CartDetailContextProvider>
                    <CartInfo cart={this.props.match.params}/>
                    <CartContent/>
                </CartDetailContextProvider>
            </CapabilityContextProvider>
        )
    }
}

export default CartDetailComponent


// WEBPACK FOOTER //
// ./src/components/cartDrillDown/CartDetailComponent.js